export default __webpack_public_path__ + "static/media/Background_00143.022cf783.png";